import classnames from 'classnames';
import React from 'react';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  size?: 'extraSmall' | 'small' | 'large';
  useAccentColor?: boolean;
}

export const Spinner = ({
  size = 'large',
  useAccentColor = false,
}: SpinnerProps) => (
  <div
    className={classnames(styles.spinner, styles[size], {
      [styles.accent]: useAccentColor,
    })}
    data-testid="spinner"
  />
);
